// src/styles/Colors.ts
export const COLORS = {
  teal: '#0098aa',
  orange: '#f19135',
  gray: '#666666',
  white: '#ffffff',
  lightGray: '#8a8c8e',
  darkGray: '#666666',
  darkTeal: '#0098aa',
  red: '#ff0000',     // Already present for errors
  success: '#28a745', // Added green for success
} as const;